import api from "../../../service/api";
import ActionTypes from "../../actionTypes";
import API_BOOK from "../../../service/endpoints";

const { GET_ALL_DATA_SUCCESS, GET_ALL_DATA_FAIL } = ActionTypes.REPORTS.KM_SUMMARY;
const { GET_KM_SUMMARY } = API_BOOK.REPORTS.KM_REPORT;

/* Action dispatchers */

const getAllKmSummarySuccessAD = (payload) => ({
  type: GET_ALL_DATA_SUCCESS,
  payload,
});

const getAllKmSummaryFailAD = () => ({
  type: GET_ALL_DATA_FAIL,
});

/* Actions */

/**
 *  @desc         Get KM Summary data
 *  @api          /reports/km-summary
 *  @method       POST
 **/
export const GetKmSummary = ({ registrationNumbers, fromDate, toDate, pageSize, pageIndex }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_KM_SUMMARY.method,
      url: GET_KM_SUMMARY.url,
      data: {
        registrationNumbers: registrationNumbers?.map((val) => val.label),
        fromDate,
        toDate,
        pageSize,
        pageIndex,
      }
    });

    if (resp.status === 200 && resp?.data?.data) {
      const response = resp?.data?.data;
      dispatch(getAllKmSummarySuccessAD(response));
    } else {
      dispatch(getAllKmSummaryFailAD());
    }
  } catch (error) {
    dispatch(getAllKmSummaryFailAD());
    console.log("error:", error);
  }
};
